import { render } from "./CzIntroduce.vue?vue&type=template&id=1472d66c&scoped=true"
import script from "./CzIntroduce.vue?vue&type=script&lang=js"
export * from "./CzIntroduce.vue?vue&type=script&lang=js"

import "./CzIntroduce.vue?vue&type=style&index=0&id=1472d66c&scoped=true&lang=css"

import exportComponent from "/Volumes/directory/IdeaProjects/Macau-Double-Color-Ball/Macau-Double-Color-Ball_Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1472d66c"]])

export default __exports__